var _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfoClean(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "2 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 12,
    r: 11,
    stroke: "#A2A9E7",
    strokeWidth: 2,
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.022 17V10.126H14.632V17H13.022ZM13.834 8.922C13.5447 8.922 13.3113 8.838 13.134 8.67C12.9567 8.502 12.868 8.278 12.868 7.998C12.868 7.72733 12.9567 7.508 13.134 7.34C13.3113 7.172 13.5447 7.088 13.834 7.088C14.1233 7.088 14.3567 7.172 14.534 7.34C14.7113 7.508 14.8 7.72733 14.8 7.998C14.8 8.278 14.7113 8.502 14.534 8.67C14.3567 8.838 14.1233 8.922 13.834 8.922Z",
    fill: "#AEB5FF",
    fillOpacity: 0.7
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoClean);
export default __webpack_public_path__ + "static/media/info-clean.3d3d5ba0375c3562d7488ac0f903b2b5.svg";
export { ForwardRef as ReactComponent };